<map-header></map-header>

<maia-step-header [currentStep]="currentFlowStep"
                  [allStepsDone]="portfolioImported"
                  (exitRequested)="exit()"
                  (uploadRequested)="openUploadPanel()"></maia-step-header>

<div class="maia-page" data-testid="maia-page">

    <!-- Hidden at the client's request, not deleted — see `chatPanelEnabled`.
         The bindings stay live so the panel's inputs/outputs keep being
         compiled against this page rather than quietly rotting while it's off. -->
    <aside class="maia-left-panel" *ngIf="chatPanelEnabled">
        <maia-chat-panel [jobId]="chatJobId"
                         (uploadRequested)="openUploadPanel()"
                         (exitRequested)="exit()"></maia-chat-panel>
    </aside>

    <section class="maia-right-panel" data-testid="maia-right-panel">

        <!-- Shown instead of an empty panel while the job in the route is
             fetched; which panel to show is decided by what comes back. -->
        <div *ngIf="isResuming" class="maia-resuming" data-testid="maia-resuming">
            <span class="maia-resuming-spinner" aria-hidden="true"></span>
            <p class="maia-resuming-text">Loading your process…</p>
        </div>

        <maia-upload-step *ngIf="activePanel === 'upload'"
                          [datasetId]="datasetId"
                          (closeRequested)="onUploadCloseRequested($event)"
                          (uploaded)="onUploaded($event)"
                          (resumeRequested)="onResumeActiveJob($event)"
                          (alreadyComplete)="onUploadAlreadyComplete($event)"></maia-upload-step>

        <maia-review-step *ngIf="activePanel === 'review'"
                          [uploadResponse]="reviewData"
                          [fileSummary]="reviewFileSummary"
                          [jobTotalRows]="reviewJobTotalRows"
                          (back)="onReviewBack()"
                          (replaceFileRequested)="onReviewReplaceFile()"
                          (closeRequested)="onReviewCloseRequested($event)"
                          (submit)="onReviewSubmit($event)"></maia-review-step>

        <maia-geocode-step *ngIf="activePanel === 'geocode'"
                           [jobId]="jobId"
                           [fileName]="reviewFileName"
                           [totalLocations]="geocodeTotalLocations"
                           [autoStart]="geocodeAutoStart"
                           (closeRequested)="onGeocodeCloseRequested($event)"
                           (continueRequested)="onGeocodeContinue()"
                           (screenChanged)="onGeocodeScreenChanged($event)"></maia-geocode-step>
        <maia-prepare-step *ngIf="activePanel === 'prepare'"
                           [mappings]="prepareMappings"
                           [jobId]="jobId"
                           (back)="onPrepareBack()"
                           (closeRequested)="onPrepareCloseRequested($event)"
                           (accepted)="onPrepareAccepted($event)"></maia-prepare-step>

        <maia-enrich-step *ngIf="activePanel === 'enrich'"
                          [datasetId]="datasetId"
                          [jobId]="jobId"
                          (closeRequested)="onGroupClose()"
                          (backRequested)="onEnrichBack()"
                          (submitted)="onEnrichSubmit($event)"></maia-enrich-step>

        <maia-enhance-step *ngIf="activePanel === 'enhance'"
                           [datasetId]="datasetId"
                           [jobId]="jobId"
                           [fileName]="reviewFileName"
                           [totalLocations]="geocodeTotalLocations"
                           [paidSelected]="enrichPaidSelected"
                           (closeRequested)="onGroupClose()"
                           (completed)="onEnhanceComplete()"></maia-enhance-step>

        <maia-ready-step *ngIf="activePanel === 'ready'"
                         [datasetId]="datasetId"
                         [jobId]="jobId"
                         [fileName]="reviewFileName"
                         [locationsDownloaded]="locationsDownloaded"
                         (closeRequested)="onGroupClose()"
                         (downloadRequested)="onReadyDownload()"
                         (overviewReportRequested)="onReadyOverviewReport()"
                         (importRequested)="onReadyImport()"></maia-ready-step>

        <maia-report-step *ngIf="activePanel === 'report'"
                          [datasetId]="datasetId"
                          [jobId]="jobId"
                          (closeRequested)="onGroupClose()"
                          (backRequested)="onReportBack()"
                          (continueRequested)="onReportContinue()"></maia-report-step>

        <maia-group-step *ngIf="activePanel === 'group'"
                         [datasetId]="datasetId"
                         [accountId]="accountIdNumber"
                         [jobId]="jobId"
                         [initialView]="resumedGroupView"
                         (closeRequested)="onGroupClose()"
                         (backRequested)="openPreparePanel()"
                         (mapRequested)="exit()"
                         (downloadRequested)="onGroupDownload()"
                         (imported)="onGroupImported()"></maia-group-step>
    </section>

    <maia-leave-dialog *ngIf="pendingLeave"
                       (stay)="stayOnPage()"
                       (leave)="leaveWithoutSaving()"></maia-leave-dialog>

</div>
